var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createRef, useContext, useEffect } from "react";
import { AvailableFilters, dataFilters, getEntity } from "../../common/filters";
import { useLookupField } from "../LookupField/LookupField";
import { FilterRestrictionContext, getRestrictionArrays, } from "../../providers/FilterRestrictionProvider";
import { getAttributeType, getClientId, LeaderAttribute, useGetDataFiltersQuery, useGetLookupsFiltersQuery, useGetLookupsQuery, } from "../../store/api/core";
import { isObject, memoize } from "lodash";
import { filterListeners, getFilters, setFilters, updateFilters, } from "../../providers/FilterProvider";
import { FilterResetEventName, MultiSelectFilter } from "./MultiSelectFilter";
import { SearchRoleNameFilter } from "./SearchRoleNameFilter";
import { FloatingSpinner } from "../SpinnerAndErrorer/SpinnerAndErrorer";
import ResetButton from "../ResetButton";
import { useClient } from "../../hooks/client";
/* eslint-disable  @typescript-eslint/no-explicit-any */
var getFunctionMap = function (data, current, result) {
    if (Array.isArray(data)) {
        return data.forEach(function (value) {
            getFunctionMap(value, current, result);
        });
    }
    if (isObject(data) &&
        (data === null || data === void 0 ? void 0 : data.code) &&
        getAttributeType(data === null || data === void 0 ? void 0 : data.code) == LeaderAttribute.Level) {
        result.levelLabels[data.code] = data.fieldValue;
    }
    if (isObject(data) &&
        (data === null || data === void 0 ? void 0 : data.code) &&
        getAttributeType(data === null || data === void 0 ? void 0 : data.code) == LeaderAttribute.PrimaryRole) {
        result.functionLabels[data.code] = data.fieldValue;
    }
    if (isObject(data) &&
        (data === null || data === void 0 ? void 0 : data.code) &&
        getAttributeType(data === null || data === void 0 ? void 0 : data.code) == LeaderAttribute.PrimaryRole &&
        (data === null || data === void 0 ? void 0 : data.subFunctions)) {
        return getFunctionMap(Object.values(data.subFunctions), data.code, result);
    }
    if (isObject(data) &&
        (data === null || data === void 0 ? void 0 : data.code) &&
        getAttributeType(data === null || data === void 0 ? void 0 : data.code) == LeaderAttribute.SecondaryRole &&
        getAttributeType(current) == LeaderAttribute.PrimaryRole) {
        result.functionFilters[data.code] = current;
        result.subFunctionLabels[data.code] = data.fieldValue;
        if (!result.subFunctionFilters[current]) {
            result.subFunctionFilters[current] = new Set();
        }
        result.subFunctionFilters[current].add(data.code);
    }
    if (isObject(data)) {
        getFunctionMap(Object.values(data), current, result);
    }
};
/* eslint-enable  @typescript-eslint/no-explicit-any */
var getMemoizedFunctionMap = memoize(function (data) {
    var result = {
        functionFilters: {},
        subFunctionFilters: {},
        functionLabels: {},
        subFunctionLabels: {},
        levelLabels: {},
    };
    getFunctionMap(data, undefined, result);
    return result;
});
export var useFunctionMap = function (_a) {
    var _b;
    var clientId = _a.clientId;
    var client = useClient();
    var clientIdToUse = clientId || client.clientId;
    var response = useGetLookupsQuery({ clientId: clientIdToUse }, { shouldSkipCall: function () { return !clientIdToUse; } });
    return getMemoizedFunctionMap((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data[0]);
};
var useFunctionRestrictions = function (entity) { return function () {
    var restrictions = useContext(FilterRestrictionContext).restrictions;
    var lookups = useLookupField({ clientId: getClientId() });
    var map = useFunctionMap({ clientId: getClientId() });
    var copy = Object.entries(restrictions || {}).reduce(function (current, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, current), (_b = {}, _b[key] = new Set(Array.from(value || new Set())), _b)));
    }, {});
    Array.from((restrictions === null || restrictions === void 0 ? void 0 : restrictions[getEntity(AvailableFilters.BusinessSubFunctions)]) || [])
        .reduce(function (current, value) { return __spreadArray(__spreadArray([], current, true), ((map === null || map === void 0 ? void 0 : map.functionFilters[value]) ? [map === null || map === void 0 ? void 0 : map.functionFilters[value]] : []), true); }, [])
        .forEach(function (value) {
        var _a;
        (_a = copy === null || copy === void 0 ? void 0 : copy[getEntity(AvailableFilters.BusinessFunctions)]) === null || _a === void 0 ? void 0 : _a.add(value);
    });
    Array.from((restrictions === null || restrictions === void 0 ? void 0 : restrictions[getEntity(AvailableFilters.BusinessFunctions)]) || [])
        .reduce(function (current, value) {
        var _a;
        return __spreadArray(__spreadArray([], current, true), (((_a = map === null || map === void 0 ? void 0 : map.subFunctionFilters[value]) === null || _a === void 0 ? void 0 : _a.size)
            ? Array.from(map === null || map === void 0 ? void 0 : map.subFunctionFilters[value])
            : []), true);
    }, [])
        .forEach(function (value) {
        var _a;
        (_a = copy === null || copy === void 0 ? void 0 : copy[getEntity(AvailableFilters.BusinessSubFunctions)]) === null || _a === void 0 ? void 0 : _a.add(value);
    });
    return { entity: entity, restrictions: copy, lookups: lookups };
}; };
var useSubFunctionOptionFilter = function (useOptions) {
    return function (_a) {
        var _b, _c, _d, _e, _f;
        var clientId = _a.clientId, filters = _a.filters;
        var response = (useOptions || useGetDataFiltersQuery)({
            clientId: clientId,
            filters: filters,
        });
        var functionMap = useFunctionMap({ clientId: clientId });
        if ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) {
            response.data.data = Object.entries(response.data.data).reduce(function (acc, _a) {
                var key = _a[0], value = _a[1];
                acc[key] =
                    key != getEntity(AvailableFilters.BusinessSubFunctions)
                        ? value
                        : (value === null || value === void 0 ? void 0 : value.map(function (val) {
                            return {
                                value: val.value,
                                label: functionMap.subFunctionLabels[val.value],
                            };
                        })) || [];
                return acc;
            }, {});
        }
        var subFunctions = ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d[getEntity(AvailableFilters.BusinessSubFunctions)]) || [];
        if (response.isFetching) {
            return response;
        }
        if (response.isError) {
            return response;
        }
        if (!(filters === null || filters === void 0 ? void 0 : filters[getEntity(AvailableFilters.BusinessFunctions)]) ||
            ((_e = filters === null || filters === void 0 ? void 0 : filters[getEntity(AvailableFilters.BusinessFunctions)]) === null || _e === void 0 ? void 0 : _e.length) == 0) {
            return response;
        }
        if (!((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.data)) {
            return response;
        }
        var copy = JSON.parse(JSON.stringify(response));
        copy.data.data[getEntity(AvailableFilters.BusinessSubFunctions)] =
            subFunctions.filter(function (subFunction) {
                return filters === null || filters === void 0 ? void 0 : filters[getEntity(AvailableFilters.BusinessFunctions)].includes(functionMap.functionFilters[subFunction.value]);
            });
        return copy;
    };
};
var SubFunctionFilter = function (_a) {
    var _b;
    var useDataSource = _a.useDataSource, disableFilters = _a.disableFilters;
    var useRestrictions = useFunctionRestrictions(dataFilters[AvailableFilters.BusinessSubFunctions].entity);
    var useOptions = useSubFunctionOptionFilter(useDataSource);
    var response = useGetLookupsQuery({ clientId: getClientId() });
    var functionMap = getMemoizedFunctionMap((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data[0]);
    var filterRereader = createRef(null);
    var eventListener = function (_a, allNext) {
        var _b = getEntity(AvailableFilters.BusinessFunctions), previous = _a[_b], _c = getEntity(AvailableFilters.BusinessSubFunctions), settable = _a[_c];
        var _d = allNext, _e = getEntity(AvailableFilters.BusinessFunctions), next = _d[_e];
        var removedFunctions = (previous || []).filter(function (value) { return !(next === null || next === void 0 ? void 0 : next.includes(value)); });
        var removedSubFunctions = removedFunctions.reduce(function (current, value) {
            return current.concat(Array.from(functionMap.subFunctionFilters[value] || []));
        }, []);
        var newSettable = Array.from(new Set(__spreadArray([], (settable || []), true).filter(function (value) { return !removedSubFunctions.includes(value); })));
        if (!newSettable.every(function (value) { return (settable || []).includes(value); }) ||
            newSettable.length != (settable === null || settable === void 0 ? void 0 : settable.length)) {
            setTimeout(function () {
                var _a;
                setFilters(__assign(__assign({}, allNext), (_a = {}, _a[getEntity(AvailableFilters.BusinessFunctions)] = next, _a[getEntity(AvailableFilters.BusinessSubFunctions)] = newSettable, _a)));
            }, 0);
        }
    };
    useEffect(function () {
        filterListeners.add(eventListener);
        return function () {
            filterListeners.delete(eventListener);
        };
    }, [response]);
    return (_jsx(MultiSelectFilter, { label: "Sub-Function", entity: dataFilters[AvailableFilters.BusinessSubFunctions].entity, filterRereader: filterRereader, useRestrictions: useRestrictions, useOptionsQuery: useOptions, disableFilters: disableFilters }));
};
var useLevelOptionFilter = function (_a) {
    var _b;
    var clientId = _a.clientId, filters = _a.filters;
    var response = useGetDataFiltersQuery({
        clientId: clientId,
        filters: filters,
    });
    var functionMap = useFunctionMap({ clientId: clientId });
    if ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) {
        response.data.data = Object.entries(response.data.data).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            acc[key] =
                key != getEntity(AvailableFilters.JobLevels)
                    ? value
                    : (value === null || value === void 0 ? void 0 : value.map(function (val) {
                        return {
                            value: val.value,
                            label: functionMap.levelLabels[val.value],
                        };
                    })) || [];
            return acc;
        }, {});
    }
    return response;
};
var useProjectsOptionQuery = function (_a) {
    var clientId = _a.clientId, filters = _a.filters;
    return useGetDataFiltersQuery({
        clientId: clientId,
        filters: filters,
    });
};
var useFunctionOptionFilter = function (useOptions) {
    return function (_a) {
        var _b, _c, _d;
        var _e, _f, _g, _h, _j, _k;
        var clientId = _a.clientId, filters = _a.filters;
        var response = (useOptions || useGetDataFiltersQuery)({
            clientId: clientId,
            filters: __assign(__assign({}, filters), (_b = {}, _b[dataFilters[AvailableFilters.BusinessFunctions].entity] = [], _b[dataFilters[AvailableFilters.BusinessSubFunctions].entity] = [], _b)),
        });
        var functionMap = useFunctionMap({ clientId: clientId });
        if (response.isFetching) {
            return response;
        }
        if (response.isError) {
            return response;
        }
        if (!(filters === null || filters === void 0 ? void 0 : filters[dataFilters[AvailableFilters.BusinessSubFunctions].entity]) ||
            (filters === null || filters === void 0 ? void 0 : filters[dataFilters[AvailableFilters.BusinessSubFunctions].entity].length) == 0) {
            return {
                data: {
                    data: __assign(__assign({}, (((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) || {})), (_c = {}, _c[dataFilters[AvailableFilters.BusinessFunctions].entity] = ((_h = (_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g[dataFilters[AvailableFilters.BusinessFunctions].entity]) === null || _h === void 0 ? void 0 : _h.map(function (_a) {
                        var _b;
                        var value = _a.value, label = _a.label;
                        return ({
                            value: value,
                            label: ((_b = functionMap === null || functionMap === void 0 ? void 0 : functionMap.functionLabels) === null || _b === void 0 ? void 0 : _b[value]) || label,
                        });
                    })) || [], _c)),
                },
            };
        }
        if (!((_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.data)) {
            return response;
        }
        var inFilters = ((_k = getFilters()) === null || _k === void 0 ? void 0 : _k[dataFilters[AvailableFilters.BusinessFunctions].entity]) ||
            [];
        inFilters.sort();
        var functionFilter = Array.from(new Set(filters === null || filters === void 0 ? void 0 : filters[dataFilters[AvailableFilters.BusinessSubFunctions].entity].map(function (value) { var _a; return (_a = functionMap === null || functionMap === void 0 ? void 0 : functionMap.functionFilters) === null || _a === void 0 ? void 0 : _a[value]; }).filter(function (value) { return value; }).concat(inFilters)));
        functionFilter.sort();
        if (JSON.stringify(functionFilter) != JSON.stringify(inFilters)) {
            updateFilters((_d = {},
                _d[getEntity(AvailableFilters.BusinessFunctions)] = functionFilter,
                _d));
        }
        var copy = { data: { data: {} } };
        copy.data.data = Object.entries(response.data.data).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            acc[key] =
                key != getEntity(AvailableFilters.BusinessFunctions)
                    ? value
                    : (value === null || value === void 0 ? void 0 : value.map(function (val) {
                        return {
                            value: val.value,
                            label: functionMap.functionLabels[val.value],
                        };
                    })) || [];
            return acc;
        }, {});
        return copy;
    };
};
var FunctionFilter = function (_a) {
    var _b;
    var useDataSource = _a.useDataSource, disableFilters = _a.disableFilters;
    var useRestrictions = useFunctionRestrictions(dataFilters[AvailableFilters.BusinessFunctions].entity);
    var response = useGetLookupsQuery({ clientId: getClientId() });
    var functionMap = getMemoizedFunctionMap((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data[0]);
    var useOptions = useFunctionOptionFilter(useDataSource);
    var eventListener = function (_a, allNext) {
        var _b = getEntity(AvailableFilters.BusinessSubFunctions), previous = _a[_b], _c = getEntity(AvailableFilters.BusinessFunctions), settable = _a[_c];
        var _d = allNext, _e = getEntity(AvailableFilters.BusinessSubFunctions), next = _d[_e];
        var subChanges = (next || []).filter(function (value) { return !(previous === null || previous === void 0 ? void 0 : previous.includes(value)); });
        var changes = subChanges.map(function (value) { return functionMap.functionFilters[value]; });
        if (!changes.every(function (value) { return settable === null || settable === void 0 ? void 0 : settable.includes(value); })) {
            var mergedFunctions_1 = Array.from(new Set(changes.concat(settable || [])));
            if (!mergedFunctions_1.every(function (value) { return settable === null || settable === void 0 ? void 0 : settable.includes(value); }) ||
                mergedFunctions_1.length != (settable === null || settable === void 0 ? void 0 : settable.length)) {
                setTimeout(function () {
                    var _a;
                    setFilters(__assign(__assign({}, allNext), (_a = {}, _a[getEntity(AvailableFilters.BusinessSubFunctions)] = next, _a[getEntity(AvailableFilters.BusinessFunctions)] = mergedFunctions_1, _a)));
                }, 0);
            }
        }
    };
    useEffect(function () {
        filterListeners.add(eventListener);
        return function () {
            filterListeners.delete(eventListener);
        };
    }, [response]);
    return (_jsx(MultiSelectFilter, { label: "Function", entity: dataFilters[AvailableFilters.BusinessFunctions].entity, useRestrictions: useRestrictions, useOptionsQuery: useOptions, disableFilters: disableFilters }));
};
var useRestrictionMaintainingReset = function () {
    var restrictions = useContext(FilterRestrictionContext).restrictions;
    var current = getFilters();
    var preserved = {};
    if (current.assessmentCategory) {
        preserved.assessmentCategory = current.assessmentCategory;
    }
    return {
        clear: function () {
            setFilters(__assign(__assign({ assessmentCategory: preserved.assessmentCategory }, getRestrictionArrays(restrictions)), { rerenderKey: Math.random() }));
        },
    };
};
var RestrictionMaintainingResetButton = function (_a) {
    var clearFilters = _a.clearFilters, disableFilters = _a.disableFilters;
    var clear = useRestrictionMaintainingReset().clear;
    return (_jsx(_Fragment, { children: _jsx(ResetButton, { disableButton: disableFilters, label: "Reset Filters", onClick: function () {
                (clearFilters || clear)();
                setTimeout(function () {
                    window.dispatchEvent(new CustomEvent(FilterResetEventName, {}));
                }, 0);
            } }, AvailableFilters.Reset) }));
};
export var filterOverrides = (_a = {},
    _a[AvailableFilters.BusinessFunctions] = function (_a) {
        var disableFilters = _a.disableFilters;
        return (_jsx(FunctionFilter, { disableFilters: disableFilters }, "business-function-filter"));
    },
    _a[AvailableFilters.BusinessFunctionSuccessProfile] = function (_a) {
        var disableFilters = _a.disableFilters;
        return (_jsx(FunctionFilter, { useDataSource: useGetLookupsFiltersQuery, disableFilters: disableFilters }, "business-function-success-profile-filter"));
    },
    _a[AvailableFilters.BusinessSubFunctions] = function (_a) {
        var disableFilters = _a.disableFilters;
        return (_jsx(SubFunctionFilter, { disableFilters: disableFilters }, "business-sub-function-filter"));
    },
    _a[AvailableFilters.BusinessSubFunctionSuccessProfile] = function (_a) {
        var disableFilters = _a.disableFilters;
        return (_jsx(SubFunctionFilter, { useDataSource: useGetLookupsFiltersQuery, disableFilters: disableFilters }, "business-sub-function-success-profile-filter"));
    },
    _a[AvailableFilters.JobLevels] = function (_a) {
        var disableFilters = _a.disableFilters;
        return (_jsx(MultiSelectFilter, { label: "Level", entity: getEntity(AvailableFilters.JobLevels), useOptionsQuery: useLevelOptionFilter, disableFilters: disableFilters }, "job-level-filter"));
    },
    _a[AvailableFilters.JobLevelSuccessProfile] = function (_a) {
        var disableFilters = _a.disableFilters;
        return (_jsx(MultiSelectFilter, { label: "Level", entity: "level", useOptionsQuery: useGetLookupsFiltersQuery, disableFilters: disableFilters }, "job-level-success-profile-filter"));
    },
    _a[AvailableFilters.Project] = function (_a) {
        var disableFilters = _a.disableFilters;
        return (_jsx(MultiSelectFilter, { useOptionsQuery: useProjectsOptionQuery, entity: getEntity(AvailableFilters.Project), label: "Project", disableFilters: disableFilters }));
    },
    _a[AvailableFilters.RoleName] = function () { return _jsx(SearchRoleNameFilter, {}); },
    _a[AvailableFilters.Spinner] = function () { return _jsx(FloatingSpinner, {}, "spinner"); },
    _a[AvailableFilters.Reset] = function (_a) {
        var clearFilters = _a.clearFilters, disableFilters = _a.disableFilters;
        return (_jsx(RestrictionMaintainingResetButton, { clearFilters: clearFilters, disableFilters: disableFilters }));
    },
    _a);
